import { Toro } from '../common/enumerations';

export class ControllerClimateLogicStatus
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            if (json['ClDateTime'])
            {
                this.ClDateTime = new Date(json['ClDateTime']);
            }
        }
    }

    BatteryVoltage: number;
    Budget: number;
    ClDateTime: Date;
    DaysReceivedWetMessage: number;
    DryoutHours: number;
    IsRemoteStationOn: boolean;
    MaxSolar: number;
    MaxTemperature: number;
    NoRfSignalDays: number;
    RmtCmdCounter: number;
    RmtCounter1: number;
    RmtCounter2: number;
    RmtCounter3: number;
    RmtCounter4: number;
    RmtCounter5: number;
    SoftAutoRunningMode: number;
    Solar: number;
    Status: Toro.ClimateLogicSensorStatus = Toro.ClimateLogicSensorStatus.Unknown;
    TemperatureInFahrenheit: number;

    // Are the values below set/used anywhere?
    IsDryWarm: boolean;
    IsRainHold: boolean;
    IsFreezeHold: boolean;
    IsClSensorBypassed: boolean;
    IsClDryoutHold: boolean;
    IsClWaterRestrictionHold: boolean;
    IsClSoftAutoOff: boolean;


    // Public Methods

    get sensorStatusString(): string
    {
        switch (this.Status)
        {
            case Toro.ClimateLogicSensorStatus.HoldRain:
                return 'Hold, Rain';

            case Toro.ClimateLogicSensorStatus.WaterDryWarm:
                return 'Water, Sensor Dry & Warm';

            case Toro.ClimateLogicSensorStatus.HoldFreeze:
                return 'Hold, Freeze';

            case Toro.ClimateLogicSensorStatus.WaterBypassed:
                return 'Water, Sensor Bypassed';

            case Toro.ClimateLogicSensorStatus.HoldDryout:
                return 'Hold, Sensor Dry Out Mode';

            case Toro.ClimateLogicSensorStatus.HoldWaterRetrict:
                return 'Hold, Water Restrict Active';

            case Toro.ClimateLogicSensorStatus.HoldAutoModeOff:
                return 'Hold, Auto Mode Off';

            default:
                return 'Unknown';
        }
    }
}
